import {
  PublicClientApplication,
  AccountInfo,
  EndSessionRequest,
  RedirectRequest,
  PopupRequest
} from "@azure/msal-browser"

import { MSAL_CONFIG } from "./ms-teams.config"

export class AzureAuthenticationContext {
  private myMSALObj: PublicClientApplication = new PublicClientApplication(
    MSAL_CONFIG
  )
  private account?: AccountInfo
  private loginRedirectRequest?: RedirectRequest
  private loginRequest?: PopupRequest
  public isAuthenticationConfigured = false

  constructor() {
    // @ts-ignore
    this.account = null
    this.setRequestObjects()
    if (MSAL_CONFIG?.auth?.clientId) {
      this.isAuthenticationConfigured = true
    }
  }

  private setRequestObjects(): void {
    this.loginRequest = {
      scopes: [],
      prompt: "select_account"
    }
    this.loginRedirectRequest = {
      ...this.loginRequest,
      redirectStartPage: window.location.href
    }
  }

  login(): Promise<any> {
    return this.myMSALObj.loginPopup(this.loginRequest)
  }

  logout(account: AccountInfo): void {
    const logOutRequest: EndSessionRequest = {
      account
    }
    this.myMSALObj.logout(logOutRequest)
  }
}

export default AzureAuthenticationContext
